import { VISIBILITY_CONTEXT, VISIBILITY_PRIVATE, VISIBILITY_PUBLIC } from '@videotools/js/api/entities/TagGroup';

const iconMap = {
	[VISIBILITY_PUBLIC]:  'world',
	[VISIBILITY_CONTEXT]: null,
	[VISIBILITY_PRIVATE]: 'lock',
};

export default {
	methods: {
		visibilityIcon(visibility) {
			return iconMap[visibility];
		},
	},
};
